import { observer } from 'mobx-react-lite';
import { globalStore } from '../../global.store';
import { ToastsContent } from '../../helpers/toasts_content';
import { ImgImporter } from '../../ui/imgImporter';
import './styles.scss';

const Toast = observer(() => {
  const { toastType, toastStatus } = globalStore;
  return (
    <div className={`toastContainer ${toastStatus && 'active'}`}>
      <div
        className={`toast_popup ${ToastsContent?.[toastType as string]?.type || toastType}`}
      >
        <div className="popup_icon">
          <ImgImporter
            path={`toasts/${ToastsContent?.[toastType as string]?.type || "info"}.svg`}
          />
        </div>
        <div className="modal_text">
          {ToastsContent?.[toastType as string]?.content || toastType}
        </div>
      </div>
    </div>
  );
});

export default Toast;
